import classNames from 'classnames';
import styles from './Select.module.scss';

/**
 * Select
 *
 * @return {JSX.Element}
 */
const Select = ({
  className,
  fullWidth,
  reverse,
  flex,
  options = [],
  onChange,
  readOnly,
  ...rest
}) => {
  const renderOption = (option) => (
    <option key={option.key} value={option.key}>
      {option.value}
    </option>
  );

  return (
    <select
      onChange={readOnly ? undefined : onChange}
      className={classNames(
        styles.Select,
        fullWidth && styles.Select__fullWidth,
        reverse && styles.Select__reverse,
        flex && styles.Select__flex,
        className,
        `${Select.displayName}`
      )}
      {...rest}
    >
      {options.map(renderOption)}
    </select>
  );
};

Select.displayName = 'Select';

export default Select;
